// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  log: true,
  environmentName: 'local',
  version: 5.5,
  api_url: '', // DEV url
  web_url: 'https://dev.houseofagents.ai/',
  image_url: 'https://image-data-hour4u-2.s3.ap-south-1.amazonaws.com/',

  orderService: 'https://u9qgrb33e5.execute-api.ap-south-1.amazonaws.com/dev/payment-service',
  ratingService: 'https://ccpff30ztf.execute-api.ap-south-1.amazonaws.com/dev/rating-service',
  authService: 'https://u9qgrb33e5.execute-api.ap-south-1.amazonaws.com/dev/auth-service',
  jobService: 'https://gjtanl9v5f.execute-api.ap-south-1.amazonaws.com/dev/enterprise-job-service',
  notificationService: 'https://5od4uho60b.execute-api.ap-south-1.amazonaws.com/dev/notification-service',
  jobSeekerService: 'https://ehxnmz317d.execute-api.ap-south-1.amazonaws.com/dev/job-seeker',
  enterpriseAdminService: 'https://gjtanl9v5f.execute-api.ap-south-1.amazonaws.com/dev/enterprise-job-service/v1',
  callingService: 'https://tr1q6rmvce.execute-api.ap-south-1.amazonaws.com/dev/',

  //India servers
  // projectAPI: 'https://g90bw5p4gf.execute-api.ap-south-1.amazonaws.com/dev/',
  // projectAPIKey: 'YEVyeT7U0K8iNxDMEpwFl9gUd7rbEbst9lHdrJwE',
  // pipecatAPI: 'https://sandbox-websocket.houseofagents.ai',

  //USA servers

  projectAPI: 'https://ytdvc6sh0j.execute-api.ap-south-1.amazonaws.com/v1/',
  projectAPIKey: 'e7bLtQfc6u29y38Z8Yu2o8rRLlMN4aNz5HSzyVGJ',
  pipecatAPI: 'https://mumbai-sandbox-websocket.houseofagents.ai',


  whatsappAPI: 'https://wa-api.houseofagents.ai',
  serriTemplatesApiUrl: 'https://api.serri.co.in/api',
  serriTemplatesApiKey: '',

  // pipecatAPI: 'http://localhost:3000',

  rezorpayKey: 'rzp_test_frWcC85VwYGHuv',
  twilioAccountSid: 'AC1022a35bc56fbf9e71220921127a0394',
  twilioAuthToken: 'ff51c9f98f3910f8c05b55bcb6ef6c8e',
  oauthClientId: 'web-client',
  oauthClientSecret: 'hour4u',
  contactSuppportNumber: "917397998705",
  googleClientId: "875702098024-j0kq8h0ms1nbt1p40v8b1cfg4lokh950.apps.googleusercontent.com",
  globalAgentId: "global",
  googleScope: 'profile email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly',
  websocketURL: 'wss://56v05lx7eb.execute-api.ap-south-1.amazonaws.com/dev/',
  metaAppId: '1392832858859365', // Facebook/Meta App ID for WhatsApp Business
  metaApiVersion: 'v21.0', // Meta API version
  interaktApiKey: 'NTg3ZUs2bUFTWjRhMjd2TEowNmlYTENhSHQ4Sm5DVkMxbTJRUzUxZmpxczo=', // Interakt API Key - set in environment-specific files
  assistantApiUrl: 'https://arya.mumbai-sandbox-websocket.houseofagents.ai',
  arya: {
    /** QR-scan connect block: ON for dev (testing with go_bridge). */
    whatsappQrConnect: true,
    /** Typed-number + Save field: ON. */
    whatsappNumberInput: true,
  },

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
